import ambuja from '../images/ambuja.png';
import dalmia from '../images/dalmia.png';
import jsw from '../images/jsw.png';
import ultratech from '../images/ultratech.png';
import gammon from '../images/gammon.png';
import unitech from '../images/unitech.jfif';
import essar from '../images/essar.png';
import jindal from '../images/jindal.png';
import landt from '../images/landt.jpg';
import bangur from '../images/bangur.png';
import jaypee from '../images/jaypee.jpg';
import realstate from '../images/real-state.png';
import dlugos from '../images/dlugos.jpg';
import dalcem from '../images/dalcem.jpg';

const image = [
    {
        id: 1,
        src: ambuja,
        alt: 'ambuja',
    },
    {
        id: 2,
        src: dalmia,
        alt: 'dalmia'
    },
    {
        id: 3,
        src: jsw,
        alt: 'jsw'
    },
    {
        id: 4,
        src: ultratech,
        alt: 'ultratech'
    },
    {
        id: 5,
        src: gammon,
        alt: 'ultratech'
    },
    {
        id: 6,
        src: unitech,
        alt: 'unitech'
    },
    {
        id: 7,
        src: essar,
        alt: 'essar'
    },
    {
        id: 8,
        src: jindal,
        alt: 'jindal'
    },
    {
        id: 9,
        src: landt,
        alt: 'landt'
    },
    {
        id: 10,
        src: bangur,
        alt: 'bangur'
    },
    {
        id: 11,
        src: jaypee,
        alt: 'jaypee'
    },
    {
        id: 12,
        src: realstate,
        alt: 'real-state'
    },
    {
        id: 13,
        src: dlugos,
        alt: 'dlugos'
    },
    {
        id: 14,
        src: dalcem,
        alt: 'dalcem'
    },
];  
export default image;